module.exports = "./img/desktop_logo.88bf102.png";